"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const clock_1 = require("@almservices-cl/clock");
const CacheKeyVO_1 = __importDefault(require("./CacheKeyVO"));
class SportActivityCache {
    constructor(cache) {
        this.cache = cache;
        this.get = async (userId, dateRange, getRequest) => {
            const keys = (0, clock_1.getDatesOfDateRange)(dateRange).map(CacheKeyVO_1.default.getActivitiesKeyFromPartial(userId));
            return this.cache.get(keys, getRequest, this.denormalize(userId), this.normalize);
        };
        this.denormalize = (userId) => (denormalized) => {
            const map = new Map();
            denormalized.forEach((day) => {
                map.set(new CacheKeyVO_1.default(userId, day.date).getActivitiesKey(), day.sportActivities);
            });
            return map;
        };
        this.normalize = (normalized) => {
            return Array.from(normalized.entries()).map(([cacheKey, sportActivities]) => ({
                date: CacheKeyVO_1.default.getDateFromKey(cacheKey),
                sportActivities,
            }));
        };
        this.getActivitiesPerDate = async (userId, dateRange, getRequest) => {
            const keys = (0, clock_1.getDatesOfDateRange)(dateRange).map(CacheKeyVO_1.default.getActivitiesPerDateKeyFromPartial(userId));
            return this.cache.get(keys, getRequest, this.denormalizeActivitiesPerDate(userId), this.normalizeActivitiesPerDate);
        };
        this.denormalizeActivitiesPerDate = (userId) => (denormalized) => {
            const map = new Map();
            denormalized.sportActivitiesPerDate.forEach(({ activitiesInDay, date }) => {
                map.set(new CacheKeyVO_1.default(userId, date).getActivitiesPerDateKey(), {
                    activitiesInDay,
                });
            });
            return map;
        };
        this.normalizeActivitiesPerDate = (normalize) => {
            return {
                sportActivitiesPerDate: Array.from(normalize.entries()).map(([cacheKey, { activitiesInDay }]) => {
                    return {
                        date: CacheKeyVO_1.default.getDateFromKey(cacheKey),
                        activitiesInDay,
                    };
                }),
            };
        };
    }
}
exports.default = SportActivityCache;
//# sourceMappingURL=SportActivityCache.js.map